import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import React from "react";
import IAPI from "../../../../models/IAPI";
import IIntegration from "../../../../models/IIntegration";
import IntegrationAPIRow from "./IntegrationAPIRow";

export interface IIntegrationAPIsTableProps {
  name: string;
  showFieldButtons: boolean;
  integration: IIntegration;
  apis: IAPI[];
}

const IntegrationAPIsTable = (props: IIntegrationAPIsTableProps) => {
  const { apis, name, showFieldButtons, integration } = props;

  const getRows = (): JSX.Element[] => {
    return apis.map((api, index) => {
      return <IntegrationAPIRow key={index} api={api} showFieldButtons={showFieldButtons} integration={integration} />;
    });
  };

  return (
    <>
      <Grid container>
        <Grid item>
          <h3>APIs in Use</h3>
        </Grid>
      </Grid>
      <TableContainer>
        <Table aria-label={`${name}Table`}>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Method</TableCell>
              <TableCell>Description</TableCell>
              <TableCell> </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{getRows()}</TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default IntegrationAPIsTable;
